export default __webpack_public_path__ + "static/6650-cc72d346069fc1b1d1bf6d1b36a90772.jpg";